import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontWeight: 600,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.primary,
  },
}))

export default useStyles
